import {
  RESET_OBJ,
  RESET_STATUS,
  API_ERROR,
  GET_MESSAGES,
  GET_MESSAGE,
  SET_MESSAGES,
  SET_MESSAGE,
  SET_AI_MESSAGE,
  SEND_MESSAGE,
  SENT_MESSAGE,
  CLOSE_CHAT,
  CLOSED_CHAT,
  GET_TABS_CHAT,
  SET_TABS_CHAT,
  TABULATE_CHAT,
  TABULATE_CHAT_TICKET,
  TABULATED_CHAT,
  DISABLE_CHAT,
  DISABLED_CHAT,
  GET_CONSUMER_CONVERSATIONS,
  SET_CONSUMER_CONVERSATIONS,
  GET_CONSUMER_MESSAGES,
  SET_CONSUMER_MESSAGES,
  START_OBSERVER,
  STARTED_OBSERVER,
  RESET_CONSUMER_OBJ,
  RESET_CONSUMER_STATUS,
  GET_CONSUMER_ERROR,
  SEND_INACTIVITY_MSG,
  SENT_INACTIVITY_MSG,
  REMOVE_MESSAGE,
  UPDATE_UNREAD_MSG,
  UPLOAD_FILE,
  UPLOADED_FILE,
  JOIN_CONVERSATION,
  JOINED_CONVERSATION,
  SAVE_MESSAGE,
  SAVE_SCROLL,
  REMOVE_SCROLL_MESSAGE,
  GET_SKILLS_ATTENDANCE,
  SET_SKILLS_ATTENDANCE,
  CREATE_ATTENDANCE,
  CREATED_ATTENDANCE,
  CREATE_COMMENTARY,
  CREATE_COMMENTARY_SUCCESS,
  CREATE_COMMENTARY_FAILURE,
  DELETE_COMMENTARY_FAILURE,
  DELETE_COMMENTARY_SUCCESS,
  DELETE_COMMENTARY,
} from "./actionTypes";

export const resetObj = () => {
  return {
    type: RESET_OBJ,
    payload: {},
  };
};
export const getSkillsAttendance = (id) => {
  return {
    type: GET_SKILLS_ATTENDANCE,
    payload: { id },
  };
};
export const setSkillsAttendance = (data, error = false) => {
  return {
    type: SET_SKILLS_ATTENDANCE,
    payload: { data, error },
  };
};
export const createAttendance = (data) => {
  return {
    type: CREATE_ATTENDANCE,
    payload: { data },
  };
};
export const createdAttendance = (data, error = false) => {
  return {
    type: CREATED_ATTENDANCE,
    payload: { data, error },
  };
};
export const resetConsumerObj = (reset) => {
  return {
    type: RESET_CONSUMER_OBJ,
    payload: reset,
  };
};
export const resetStatus = (reset) => {
  return {
    type: RESET_STATUS,
    payload: reset,
  };
};
export const resetConsumerStatus = (reset) => {
  return {
    type: RESET_CONSUMER_STATUS,
    payload: reset,
  };
};

// TODO: remove this method it is not used anywhere
export const loadMessages = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_MESSAGES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
export const getConsumerError = (error) => {
  return {
    type: GET_CONSUMER_ERROR,
    payload: error,
  };
};

export const closeChat = (id, data) => {
  return {
    type: CLOSE_CHAT,
    payload: { id, data },
  };
};
export const closedChat = (data) => {
  return {
    type: CLOSED_CHAT,
    payload: data,
  };
};

export const getTabsChat = (chatId, conversations, isInformative) => {
  return {
    type: GET_TABS_CHAT,
    payload: { chatId, conversations, isInformationTab: isInformative },
  };
};
export const setTabsChat = (data) => {
  return {
    type: SET_TABS_CHAT,
    payload: data,
  };
};

export const tabulateChat = (id, data) => {
  return {
    type: TABULATE_CHAT,
    payload: { id, data },
  };
};
export const tabulateChatTicket = (id, data) => {
  return {
    type: TABULATE_CHAT_TICKET,
    payload: { id, data },
  };
};
export const tabulatedChat = (data) => {
  return {
    type: TABULATED_CHAT,
    payload: data,
  };
};

export const disableChat = (data) => {
  return {
    type: DISABLE_CHAT,
    payload: data,
  };
};
export const disabledChat = (data) => {
  return {
    type: DISABLED_CHAT,
    payload: data,
  };
};

// TODO: remove this method it is not used anywhere
export const getMessage = () => {
  return {
    type: GET_MESSAGE,
    payload: {},
  };
};
export const setMessageAi = (message, messageId, conversationId) => {
  return {
    type: SET_AI_MESSAGE,
    payload: { message, messageId, conversationId },
  };
};

export const setMessage = (data) => {
  return {
    type: SET_MESSAGE,
    payload: data,
  };
};

export const getMessages = (id, interval) => {
  return {
    type: GET_MESSAGES,
    payload: { id, interval },
  };
};
export const setMessages = (data) => {
  return {
    type: SET_MESSAGES,
    payload: data,
  };
};

export const startObserver = (id) => {
  return {
    type: START_OBSERVER,
    payload: { id },
  };
};
export const startedObserver = (data) => {
  return {
    type: STARTED_OBSERVER,
    payload: data,
  };
};

export const agentInactivitate = (data) => {
  return {
    type: SEND_INACTIVITY_MSG,
    payload: data,
  };
};
export const agentInactivitated = (data) => {
  return {
    type: SENT_INACTIVITY_MSG,
    payload: data,
  };
};

export const getConsumerConversations = (id, typeChannel) => {
  return {
    type: GET_CONSUMER_CONVERSATIONS,
    payload: { id, typeChannel },
  };
};
export const setConsumerConversations = (id, data) => {
  return {
    type: SET_CONSUMER_CONVERSATIONS,
    payload: { id, data },
  };
};

export const getConsumerMessages = (id, page, qnt) => {
  return {
    type: GET_CONSUMER_MESSAGES,
    payload: { id, page, qnt },
  };
};
export const setConsumerMessages = (id, data) => {
  return {
    type: SET_CONSUMER_MESSAGES,
    payload: { id, data },
  };
};

export const sendMessage = (data, isPrivate) => {
  return {
    type: SEND_MESSAGE,
    payload: { data, isPrivate },
  };
};
export const sentMessage = (data) => {
  return {
    type: SENT_MESSAGE,
    payload: data,
  };
};

export const uploadFile = (data) => {
  return {
    type: UPLOAD_FILE,
    payload: data,
  };
};
export const uploadedFile = (data) => {
  return {
    type: UPLOADED_FILE,
    payload: data,
  };
};

export const removeMessage = (data) => {
  return {
    type: REMOVE_MESSAGE,
    payload: { data },
  };
};

export const updateUnreadMsg = (data) => {
  return {
    type: UPDATE_UNREAD_MSG,
    payload: { data },
  };
};

export const joinConversation = (id) => {
  return {
    type: JOIN_CONVERSATION,
    payload: id,
  };
};
export const joinedConversation = () => {
  return {
    type: JOINED_CONVERSATION,
    payload: {},
  };
};

export const saveMessage = (id, message) => {
  return {
    type: SAVE_MESSAGE,
    payload: { id, message },
  };
};

export const saveScroll = (id, scroll) => {
  return {
    type: SAVE_SCROLL,
    payload: { id, scroll },
  };
};

export const removeScrollMessage = (id) => {
  return {
    type: REMOVE_SCROLL_MESSAGE,
    payload: { id },
  };
};

export const createCommentary = (id, message, isPublic) => {
  return {
    type: CREATE_COMMENTARY,
    payload: { id, message, isPublic },
  };
};

export const createCommentarySuccess = () => {
  return {
    type: CREATE_COMMENTARY_SUCCESS,
  };
};

export const createCommentaryFailure = (error) => {
  return {
    type: CREATE_COMMENTARY_FAILURE,
    payload: { error },
  };
};

export const deleteCommentary = (conversationId, id) => {
  return {
    type: DELETE_COMMENTARY,
    payload: { id, conversationId },
  };
};

export const deleteCommentarySuccess = () => {
  return {
    type: DELETE_COMMENTARY_SUCCESS,
  };
};

export const deleteCommentaryFailure = (error) => {
  return {
    type: DELETE_COMMENTARY_FAILURE,
    payload: { error },
  };
};
